// extracted by mini-css-extract-plugin
module.exports = {"loading":"loader_loading__1C0ex","spinner":"loader_spinner__o5PzF"};